module.exports = "./img/desktop_logo.cec0aeb.png";